export const Header = [{
  prop: 'STORAGE_NO',
  label: '台账号'
}, {
  prop: 'CHEM_NAME',
  label: '试剂命名称'
}, {
  prop: 'CHEM_ID',
  label: 'CAS号'
}, {
    prop: 'PURTY',
    label: '纯度'
},{
    prop: 'CABINET_ID',
    label: '柜号'
},{
    prop: 'CURRENT_VOLUME',
    label: '余量（g）'
}]

